import { Menu } from "./menu.model";

export const horizontalMenuItems = [
  new Menu(1, "NAV.HOME", "/", null, null, false, 0),
];

export const verticalMenuItems = [
  new Menu(1, "NAV.HOME", "/", null, null, false, 0),
];
